import { useTranslation } from "next-i18next";

import BlogCard from "./BlogCard";

const OtherBlogs = ({ blogs }) => {
  const { t } = useTranslation();

  return (
    <section>
      <h3 className="font-poppins font-semibold text-[24px] md:text-[30px] mb-[24px]">
        {t("blog:blog-read-other-blogs")}
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-[24px]">
        {blogs?.map(blog => {
          return <BlogCard key={blog.id} blog={blog} />;
        })}
      </div>
    </section>
  );
};

export default OtherBlogs;
